import { getLastPastTenPeriod, getPastTenPeriod,
  getSpecifiedPeriodPrediction } from '@/api/public/images'

export default {
  domain: process.env.MARKSIX_SERVER_HOST,
  appName: process.env.PM2_APP_NAME,
  imageApi: { getLastPastTenPeriod, getPastTenPeriod,
    getSpecifiedPeriodPrediction }
}
